module.exports = __webpack_public_path__ + "img/secondary-main.a23e7dc2.jpg";